<template>
    <div class="page">
        <p>
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}
            <br />
            {{ userStore.user.address }}
            <br />
            {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
        </p>
        <p>
            {{ date }}
        </p>
        <p>
            {{ creditBureau.address_name }} <br />
            {{ address.street }} <br />
            {{ address.city }}, {{ address.state_abbreviation }}
            {{ address.zipcode }}
        </p>
        <p>
            <b>
                Re:	Dispute of inaccurate and/or incomplete information in consumer report 
            </b>
        </p>
        <p>
            To {{ creditBureau.address_name }}:
        </p>
        <p class="letter-content">
            You are reporting inaccurate and/or incomplete information concerning me in consumer reports. Your conduct has caused me distress and financially harmed me with costs and loss opportunity.
        </p>
        <p class="letter-content">
            The following tradeline you are reporting concerning me is inaccurate and/or incomplete:
        </p>
        <p v-for="creditor in reportStore.getSelectedAccounts(1, creditBureau.id, null, reportStore.getFilter())">
            Tradeline: {{ creditor.furnisher_name }};
            account number: 
            <template v-if="creditor.reference_number">
                {{ creditor.reference_number }}
            </template>
            <template v-else>
                {{ creditor.account_number }}
            </template>.
            <br />
            The tradeline is inaccurate because I am not legally obligated to {{ creditor.furnisher_name }}/{{ creditor.account_number }} in the amount of ${{ creditor.balance }} for the alleged repossession deficiency claim. Furthermore, the tradeline is incomplete because 
            <template v-if="creditor.reason">
                {{ creditor.reason }}
            </template>.
        </p>
        <p class="letter-content">
            I request that you delete the above tradeline and provide me an updated copy of my consumer file. Inform any person that you previously reported the now deleted tradeline that it is now deleted. Should you conclude that the tradeline is verified, then I request your method of verification.
        </p>
        <p class="letter-content">
            My full name is above. My social security # is {{ userStore.user.ssn }}. my date of birth is {{ userStore.user.dob }}. Enclosed please find a copy of identification as proof of identity and current mailing address.
        </p>
        <p class="letter-content">
            In addition, I request a description of the procedure used to determine the accuracy and completeness of the information of the above-listed disputed information that you included in a consumer report that you prepared and published about me, including, but not limited to, the business name and address of all furnishers of information contacted in connection with such information and the telephone number of such furnishers when you initially prepared the consumer report with the information, investigated the data, and reinvestigated it due to my current dispute.
        </p>
        <p class="letter-content">
            Unfortunately, it appears that you do not have reasonable procedures in place to assure maximum accuracy and completeness of the information that you include in your consumer reports that you prepare concerning me. Therefore, I request that any future inclusion of consumer information concerning me be sent to me first for my review before you prepare and publish any information in a consumer report about me so that I can confirm the accuracy and completeness of the same. Your prompt attention to this important matter is requested in order to comply with federal law. 
        </p>
        <p style="page-break-after: always;">
            Sincerely,
            <br />
            {{ userStore.user.firstname }} {{ userStore.user.lastname }}<br />
        </p>
    </div>
    <div class="page-content">
        <h1 style="padding: 0rem; 3rem; text-align: center;">Enclosures</h1>
        <p style="padding-top:3rem; text-align: center;">
            <img v-if='userStore.user.ssn_image_url' v-bind:src='userStore.user.ssn_image_url' width='300' height='200' />
            <img v-if='userStore.user.identity_image_url' v-bind:src='userStore.user.identity_image_url' width='300' height='200' />
        </p>
        <p v-if='userStore.user.address_verify_image_url'>
            <img v-bind:src='userStore.user.address_verify_image_url' width='300' height='200' />
        </p>
    </div>
</template>
<script>
    import { ref, reactive, computed } from 'vue'
    import { useReportStore } from '../../../../stores/ReportStore.js'
    import { useUserStore } from '../../../../stores/UserStore.js'
    import moment from 'moment';
    export default {
        props: {
            creditBureau: {
                type: [Array, Object]
            }
        },
        setup(props) {
            const address = _.find(props.creditBureau.addresses, { 'id': props.creditBureau.selected_address });
            return {
                date: ref(moment().format('LL')),
                reportStore: useReportStore(),
                userStore: useUserStore(),
                _: _,
                address,
            };
        }
    };
</script>
